<template>
    <notification-item
        title="Hráč opustil tým"
        :created="data.created"
        :author="data.payload.userName"
        avatar="/img/myteam/Avatar.png"
        :link="{ name: 'userDetail', params: { id: data.payload.userId } }"
    >
        <p>Hráč <span class="semibold semibold--textgreen"><router-link :to="{ name: 'userDetail', params: { id: data.payload.userId } }">{{ data.payload.userName }}</router-link></span> opustil váš tým.</p>
    </notification-item>
</template>

<script>
    import NotificationMixin from '../NotificationMixin';

    export default {
        name: 'MemberLeftTeam',
        mixins: [NotificationMixin],
    }
</script>
